// Shown when an import's "generate" destination runs without a query-tab context
// (e.g. the saved-import runner, or the wizard launched outside a Browser): the
// generated INSERTs in a copyable box. Shared by ImportDialog + ImportRunner.
//
// Props: sql (string), onClose()
import Modal from './Modal.jsx';
import { copyText } from '../lib/export.js';
import { toast } from '../lib/toast.js';

export default function GeneratedSqlModal(props) {
  const copy = async () => {
    try {
      await copyText(props.sql || '');
      toast.success('Copied to clipboard.');
    } catch {
      toast.error('Copy failed — select the text and copy manually.');
    }
  };
  return (
    <Modal open={true} title="Generated INSERT statements" onClose={props.onClose} wide={true}>
      <div class="import-dialog">
        <p class="muted" style="font-size:12px;">Copy these into a query editor to review and run.</p>
        <textarea class="input import-sql-out" readonly rows="16">{props.sql}</textarea>
        <div class="restore-actions">
          <button class="btn btn-ghost" onClick={props.onClose}>Close</button>
          <button class="btn btn-primary" onClick={copy}>Copy to clipboard</button>
        </div>
      </div>
    </Modal>
  );
}
